import { render } from "./Home.vue?vue&type=template&id=b309b0b2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b309b0b2&scoped=true&lang=scss"

import exportComponent from "/home/ste/vue/lotto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b309b0b2"]])

export default __exports__